import Modal from '@/components/Modal/Modal';
import { SendWalletModal } from './SendWalletModal';
import { SendFriendsModal } from './SendFriendsModal';
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import { useWalletAddress } from '@/features/account-abstraction/hooks/useWalletAddress';
import useWalletBalance from '@/hooks/useWalletBalance';
import config from '@/common/config';
import useGetFriends from '@/services/friends/queries/useGetFriends';
import useGetReferrals from '@/services/referrals/queries/useGetReferrals';
import TabHeader from '@/components/TabHeader/TabHeader';

const sendTabs: string[] = ['My Wallet', 'My Friends', 'My Referrals'];

const SendModalContainer = ({
  open,
  setClose,
  defaultTabIndex = 0,
  defaultTransferId,
}: {
  open: boolean;
  setClose: () => void;
  defaultTabIndex?: number;
  defaultTransferId?: string;
}) => {
  const onClose = () => {
    setClose();
  };
  const { walletAddress } = useWalletAddress();

  const { data: friendsData } = useGetFriends();
  const { data: referralsData } = useGetReferrals();

  const { data: usdtBalance } = useWalletBalance(walletAddress, config.contracts.usdt);

  const balance = usdtBalance ? usdtBalance.displayBalance : '-';

  return (
    <Modal
      open={open}
      setClose={setClose}
      className="lg:min-w-[500px]"
      titleComponent={
        <Modal.Title onClose={onClose} title="Transfer Funds" subtitle="Choose who you want to send funds to below" />
      }
    >
      <TabGroup defaultIndex={defaultTabIndex}>
        <TabList className="my-5 flex w-full">
          {sendTabs.map((tab) => (
            <Tab className="w-full focus:outline-none" key={tab}>
              {({ selected }) => <TabHeader tabLabel={tab} selected={selected} />}
            </Tab>
          ))}
        </TabList>
        <TabPanels>
          <TabPanel>
            <SendWalletModal onClose={onClose} balance={balance} />
          </TabPanel>
          <TabPanel>
            <SendFriendsModal
              defaultTransferId={defaultTransferId}
              inputPlaceHolder="Select a friend"
              users={friendsData?.data || []}
              onClose={onClose}
              balance={balance}
              userType="Friend"
            />
          </TabPanel>
          <TabPanel>
            <SendFriendsModal
              inputPlaceHolder="Select a referral"
              users={referralsData?.data || []}
              onClose={onClose}
              balance={balance}
              userType="Referral"
            />
          </TabPanel>
        </TabPanels>
      </TabGroup>
    </Modal>
  );
};

export default SendModalContainer;
